"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStackedBar = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledStackedBar = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 24px;\n\n  &.outerLabel {\n    margin-top: ", ";\n  }\n\n  div:last-child {\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  div:first-child {\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  height: 24px;\n\n  &.outerLabel {\n    margin-top: ", ";\n  }\n\n  div:last-child {\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n  }\n\n  div:first-child {\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
});
var templateObject_1;
